import ElementPlus from 'element-plus'
import '../element-variables.scss'
import { App } from 'vue'

const installElementPlus: (app: App) => void = (app) => {
  app.use(ElementPlus)
}  

export default installElementPlus
